import {addEventHandlers} from "./visibility-tracker-event-handlers";

export const createVisibilityTrackerStoreEnhancer = (options) =>
  (createStore) =>
    (...args) =>
      addEventHandlers(createStore(...args), options);
